<div class="warn-dialog">
  <div class="title">
    <p>
      <img src="../../../../../../assets/svg/icons/warning.svg" alt="Aviso" />
      Desvincular pessoa
    </p>
    <mat-icon style="cursor: pointer; color: #5F6368;" (click)="onCancel()">close</mat-icon>
  </div>

  <hr />

  <div class="content">
    <p>
      Ao confirmar, a pessoa selecionada
      <strong>será desvinculada</strong>
      dessa análise postural.
    </p>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">Desvincular</button>
  </div>
</div>
